var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.post.front_container==='premium')?_c('div',{staticClass:"badge"}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }